import React, { useState, useEffect } from 'react'
import { Outlet, Link, NavLink, useLocation } from 'react-router-dom'
import logoImg from '../../images/sd-q-logo.png'
import logoImg2 from '../../images/sd-q-logo-white.png'

import sbm from '../../images/sbm.png'
import rahbar from '../../images/rahbarfoundation.png'
import psf from '../../images/psf.png'
import ChatBot from '../common/ChatBot';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000'
export const imgUrl = (p) => (p ? `${API_BASE}/${p.replace(/^\//, '')}` : null)

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Courses', to: '/courses' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Placements', to: '/placements' },
  { label: 'Contact', to: '/contact' },
]

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])
  return null
}

export default function PublicLayout() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { pathname } = useLocation()
  useEffect(() => {
    setMenuOpen(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])

  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      {/* ── Sticky Navbar ── */}
      <header
        style={{
          background: '#fff',
          borderBottom: '1px solid #E5E7EB',
          position: 'sticky',
          top: 0,
          zIndex: 100,
          boxShadow: '0 2px 8px rgba(0,0,0,.05)',
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: '0 auto',
            padding: '0 20px',
            height: 66,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          {/* Logo */}
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              flexShrink: 0,
              marginRight: 8,
            }}
          >
            <img
              src={logoImg}
              alt="SD Hub Qutubshahi"
              style={{ height: 48, width: 'auto' }}
            />
          </Link>

          {/* Nav links — desktop */}
          <nav
            className="pub-nav"
            style={{
              display: 'flex',
              gap: 2,
              flex: 1,
              justifyContent: 'center',
            }}
          >
            {NAV_LINKS.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                style={({ isActive }) => ({
                  padding: '7px 11px',
                  borderRadius: 7,
                  fontSize: '.8rem',
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? '#4F46E5' : '#4B5563',
                  background: isActive ? '#EEF2FF' : 'transparent',
                  transition: 'all .15s',
                  textDecoration: 'none',
                  letterSpacing: '.02em',
                  whiteSpace: 'nowrap',
                })}
              >
                {label}
              </NavLink>
            ))}
          </nav>

          {/* Right: Login + Apply buttons */}
          <div
            className="pub-nav"
            style={{
              display: 'flex',
              gap: 8,
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Link
              to="/login"
              style={{
                padding: '7px 14px',
                borderRadius: 8,
                border: '1px solid #E5E7EB',
                color: '#374151',
                fontSize: '.82rem',
                fontWeight: 600,
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                transition: 'all .15s',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#4F46E5'
                e.currentTarget.style.color = '#4F46E5'
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#E5E7EB'
                e.currentTarget.style.color = '#374151'
              }}
            >
              Login
            </Link>
            <Link
              to="/apply"
              style={{
                padding: '7px 14px',
                borderRadius: 8,
                background: 'linear-gradient(135deg,#4F46E5,#06B6D4)',
                color: '#fff',
                fontSize: '.82rem',
                fontWeight: 600,
                textDecoration: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              Apply Free
            </Link>
          </div>

          {/* Hamburger */}
          <button
            onClick={() => setMenuOpen((m) => !m)}
            className="hamburger-nav-btn"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.4rem',
              display: 'none',
              marginLeft: 'auto',
              padding: '4px',
              color: '#374151',
            }}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div
            style={{
              background: '#fff',
              borderTop: '1px solid #E5E7EB',
              padding: '12px 20px 16px',
            }}
          >
            {NAV_LINKS.map(({ label, to }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                onClick={() => setMenuOpen(false)}
                style={({ isActive }) => ({
                  display: 'block',
                  padding: '10px 12px',
                  borderRadius: 8,
                  marginBottom: 2,
                  fontSize: '.9rem',
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#4F46E5' : '#111827',
                  background: isActive ? '#EEF2FF' : 'transparent',
                  textDecoration: 'none',
                })}
              >
                {label}
              </NavLink>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <Link
                to="/login"
                onClick={() => setMenuOpen(false)}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  padding: '10px',
                  borderRadius: 8,
                  border: '1px solid #E5E7EB',
                  color: '#374151',
                  fontSize: '.875rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                Login
              </Link>
              <Link
                to="/apply"
                onClick={() => setMenuOpen(false)}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  padding: '10px',
                  borderRadius: 8,
                  background: '#4F46E5',
                  color: '#fff',
                  fontSize: '.875rem',
                  fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                Apply Free
              </Link>
            </div>
            <div
              style={{
                padding: '10px 12px',
                color: '#6B7280',
                fontSize: '.82rem',
                marginTop: 4,
              }}
            >
              📞{' '}
              <a href="tel:+919154944461" style={{ color: '#4F46E5' }}>
                +91 915-494-4461
              </a>
            </div>
          </div>
        )}
      </header>

      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      {/* ── Footer ── */}
      <footer style={{ background: '#111827', color: '#9CA3AF' }}>
        <div
          style={{ maxWidth: 1200, margin: '0 auto', padding: '56px 24px 0' }}
        >
          <div
            className="footer-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: '2fr 1fr 1fr 1fr',
              gap: 48,
              marginBottom: 48,
            }}
          >
            {/* Brand */}
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  marginBottom: 16,
                }}
              >
                <img
                  src={logoImg2}
                  alt="SD Hub Qutubshahi"
                  style={{ height: 54, width: 'auto' }}
                />
              </div>
              <p
                style={{
                  fontSize: '.85rem',
                  lineHeight: 1.8,
                  marginBottom: 20,
                }}
              >
                Premier destination for free job-oriented technology training in
                Hyderabad. Empowering individuals with industry-ready skills.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4
                style={{
                  color: '#fff',
                  fontFamily: 'Sora',
                  fontSize: '.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '.1em',
                  marginBottom: 16,
                }}
              >
                Quick Links
              </h4>
              {[
                ['About Us', '/about'],
                ['Contact', '/contact'],
                ['Apply Free', '/apply'],
                ['Sign In', '/login'],
              ].map(([l, to]) => (
                <Link
                  key={to}
                  to={to}
                  style={{
                    display: 'block',
                    color: '#9CA3AF',
                    fontSize: '.85rem',
                    marginBottom: 10,
                    textDecoration: 'none',
                  }}
                  onMouseOver={(e) => (e.target.style.color = '#fff')}
                  onMouseOut={(e) => (e.target.style.color = '#9CA3AF')}
                >
                  › {l}
                </Link>
              ))}
            </div>

            {/* Information */}
            <div>
              <h4
                style={{
                  color: '#fff',
                  fontFamily: 'Sora',
                  fontSize: '.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '.1em',
                  marginBottom: 16,
                }}
              >
                Information
              </h4>
              {[
                ['Courses', '/courses'],
                ['Gallery', '/gallery'],
                ['Placements', '/placements'],
                ['Support', '/contact'],
              ].map(([l, to]) => (
                <Link
                  key={to}
                  to={to}
                  style={{
                    display: 'block',
                    color: '#9CA3AF',
                    fontSize: '.85rem',
                    marginBottom: 10,
                    textDecoration: 'none',
                  }}
                  onMouseOver={(e) => (e.target.style.color = '#fff')}
                  onMouseOut={(e) => (e.target.style.color = '#9CA3AF')}
                >
                  › {l}
                </Link>
              ))}
            </div>
            {/* Contact info */}
            <div style={{ fontSize: '.82rem', lineHeight: 2 }}>
              <div>
                📞{' '}
                <a
                  href="tel:+919154944461"
                  style={{ color: '#9CA3AF', textDecoration: 'none' }}
                >
                  +91 915-494-4461
                </a>
              </div>
              <div>
                📧{' '}
                <a
                  href="mailto:info@sdhubqutubshahi.com"
                  style={{ color: '#9CA3AF', textDecoration: 'none' }}
                >
                  info@sdhubqutubshahi.com
                </a>
              </div>
              <div>⏰ Mon–Sat: 9:00 AM – 6:00 PM &nbsp;|&nbsp; Sun: Closed</div>
              <div style={{ display: 'flex', gap: 10 }}>
                {[
                  {
                    label: 'LinkedIn',
                    href: 'https://www.linkedin.com/company/sdhub-qutubshahi/',
                    svg: (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                      </svg>
                    ),
                  },
                  {
                    label: 'Instagram',
                    href: 'https://www.instagram.com/sdhubqutubshahi?igsh=aTJveHRubHNtbDE0',
                    svg: (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5A3.75 3.75 0 0 1 7.75 4zm8.75 1a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 16.5 5zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
                      </svg>
                    ),
                  },
                  {
                    label: 'WhatsApp',
                    href: 'https://wa.me/919154944461',
                    svg: (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                       <path d="M20.52 3.48A11.83 11.83 0 0 0 12.07 0C5.5 0 .16 5.34.16 11.91c0 2.1.55 4.15 1.59 5.96L0 24l6.31-1.65a11.89 11.89 0 0 0 5.76 1.47h.01c6.57 0 11.91-5.34 11.91-11.91 0-3.18-1.24-6.17-3.47-8.43zM12.08 21.8a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.75.98 1-3.66-.23-.38a9.83 9.83 0 1 1 8.35 4.64zm5.39-7.35c-.29-.14-1.73-.85-2-.95-.27-.1-.47-.14-.67.14s-.77.95-.95 1.14c-.17.19-.35.21-.64.07-.29-.14-1.23-.45-2.34-1.44-.86-.77-1.45-1.72-1.62-2.01-.17-.29-.02-.45.13-.59.13-.13.29-.35.43-.52.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.19 0-.5.07-.76.36-.26.29-1 1-.97 2.43.02 1.43 1.03 2.81 1.17 3 .14.19 2.02 3.08 4.89 4.32.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.12.55-.08 1.73-.71 1.98-1.39.24-.69.24-1.28.17-1.4-.07-.12-.26-.19-.55-.33z" />
                      </svg>
                    ),
                  },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      background: 'rgba(255,255,255,.07)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#9CA3AF',
                      textDecoration: 'none',
                      transition: 'all .15s',
                      marginTop: 10,
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,.14)'
                      e.currentTarget.style.color = '#fff'
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,.07)'
                      e.currentTarget.style.color = '#9CA3AF'
                    }}
                  >
                    {s.svg}
                  </a>
                ))}
              </div>
            </div>
          </div>
          {/* Sponsor logo placeholders */}
          <div style={{ display: 'flex', gap: 10 }}>
            {[
              {
                label: 'Rahbar Foundation',
                href: 'https://rahbarfoundation.org/',
                image: rahbar,
              },
              {
                label: 'Professionals Solidarity Forum (PSF)',
                href: 'https://psfhyd.org/',
                image: psf,
              },
              {
                label: 'The Safa Educational Welfare & Charitable Trust',
                href: 'https://safatrust.org/',
                image: sbm,
              },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,.07)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#9CA3AF',
                  textDecoration: 'none',
                  transition: 'all .15s',
                  marginBottom: 20,
                }}
               
              >
                {s.image && <img src={s.image} alt={s.label} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%',}} />}
              </a>
            ))}
          </div>
          {/* Bottom bar */}
          <div
            style={{
              borderTop: '1px solid #1F2937',
              padding: '20px 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 12,
            }}
          >
            <p style={{ fontSize: '.78rem', color: '#4B5563' }}>
              © {new Date().getFullYear()} SD Hub Qutubshahi. All rights
              reserved. | Managed by Professionals Solidarity Forum (PSF)
            </p>
            {/* Social icons */}

            <div
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '.78rem',
                 color: '#4B5563'
              }}
            >
              <p>
                Design & Develop By{' '}
                <a href="https://luminatewebsol.com/" style={{ color: 'blue' }}>
                  Luminate Web Solutions
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>

      <ChatBot />

      <div
        style={{
          position: 'fixed',
          bottom: '16px',
          right: '16px',
          zIndex: 999,
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        {/* WhatsApp Text */}
        <span
          style={{
            display: window.innerWidth >= 640 ? 'flex' : 'none',
            background: '#ffffff',
            color: '#1f2937',
            fontSize: '14px',
            fontWeight: '500',
            padding: '8px 16px',
            borderRadius: '9999px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
            border: '1px solid #e5e7eb',
          }}
        >
          WhatsApp Chat
        </span>

        {/* WhatsApp Button */}
        <a
          href="https://wa.me/919154944461"
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            background: '#22c55e',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
            textDecoration: 'none',
            boxShadow: '0 8px 25px rgba(34,197,94,0.45)',
            border: '1px solid rgba(255,255,255,0.1)',
            transition: 'all 0.3s ease',
            animation: 'bounce 1.5s infinite',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#16a34a'
            e.currentTarget.style.transform = 'scale(1.1)'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = '#22c55e'
            e.currentTarget.style.transform = 'scale(1)'
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)'
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)'
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.52 3.48A11.8 11.8 0 0 0 12.04 0C5.5 0 .18 5.32.18 11.86c0 2.09.55 4.13 1.59 5.93L0 24l6.39-1.67a11.8 11.8 0 0 0 5.65 1.44h.01c6.54 0 11.86-5.32 11.86-11.86 0-3.17-1.24-6.15-3.39-8.43zM12.05 21.6a9.7 9.7 0 0 1-4.95-1.36l-.35-.21-3.79.99 1.01-3.69-.23-.38a9.7 9.7 0 0 1-1.49-5.1c0-5.38 4.38-9.76 9.77-9.76 2.61 0 5.06 1.02 6.9 2.87a9.68 9.68 0 0 1 2.86 6.89c0 5.39-4.38 9.77-9.73 9.77zm5.36-7.29c-.29-.15-1.71-.84-1.98-.94-.26-.1-.46-.15-.65.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.44.13-.58.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.48-.65-.49h-.55c-.19 0-.51.07-.78.36-.26.29-1.01.99-1.01 2.41 0 1.42 1.03 2.79 1.17 2.99.15.19 2.03 3.1 4.92 4.35.69.3 1.23.48 1.65.61.69.22 1.32.19 1.81.12.55-.08 1.71-.7 1.95-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34z" />
          </svg>
        </a>
      </div>

      <style>{`
        @media(max-width:900px){
          .pub-nav{display:none!important;}
          .hamburger-nav-btn{display:flex!important;}
          .footer-grid{grid-template-columns:1fr!important;}
        }
      `}</style>
    </div>
  )
}
